import React from 'react';
import { Check, X } from 'lucide-react';
import { Badge } from '@atoms';

export interface UserStatusBadgesProps {
  /** Whether the user is active */
  isActive: boolean;
  /** Whether the user has admin privileges */
  isAdmin: boolean;
  /** Additional CSS classes */
  className?: string;
}

/**
 * UserStatusBadges Molecule Component
 * 
 * Displays user status (active/inactive) and admin badge if applicable.
 * 
 * @example
 * ```tsx
 * <UserStatusBadges isActive={true} isAdmin={false} />
 * ```
 */
export const UserStatusBadges: React.FC<UserStatusBadgesProps> = ({
  isActive,
  isAdmin,
  className = '',
}) => {
  return (
    <div className={`flex flex-col space-y-1 ${className}`}>
      <div className="flex items-center space-x-2">
        {isActive ? (
          <>
            <Check className="w-4 h-4 text-green-500" />
            <span className="text-sm text-green-600">Active</span>
          </>
        ) : (
          <>
            <X className="w-4 h-4 text-red-500" />
            <span className="text-sm text-red-600">Inactive</span>
          </>
        )}
      </div>
      {isAdmin && (
        <Badge variant="purple">
          Admin
        </Badge>
      )}
    </div>
  );
};
